











import { Component, Prop, Vue } from 'vue-property-decorator';
import { CommandIf } from '../../cablin/commands';
import ExprComp from '../expr/Expr.vue';
import CommandListComp from './CommandList.vue';

@Component({
  components: {
    ExprComp,
    CommandListComp,
  },
})
export default class CommandIfComp extends Vue {
  @Prop() private cmd!: CommandIf
}
